// @flow weak

import React from 'react';

import AsyncIndicator from 'app/common/components/AsyncIndicator';
import 'app/common/components/LoadingBlock.scss';

const LoadingBlock = () => (
  <div className="loading-block">
    <AsyncIndicator />
  </div>
);

LoadingBlock.displayName = 'LoadingBlock';

export default LoadingBlock;
